<template>
  <b-row class="no-gutters align-items-center">
    <b-col class="col-8 col-md-6 col-lg-4">
      <search-input
        v-model="searchInput"
        label="search"
        :placeholder="$t('search')"
        @search="search"
      ></search-input>
    </b-col>
    <b-col class="col-12 mb-4 mb-sm-0 col-md-6 col-lg-4 pl-3">
      <b-form-checkbox v-model="filterRegistered">
        {{ $t("page.event.showRegistered") }}
      </b-form-checkbox>
    </b-col>
  </b-row>
</template>

<script>
import SearchInput from "../Base/BaseSearchInput";

export default {
  props: {
    eventId: {
      type: String,
      required: true
    }
  },
  components: {
    SearchInput
  },
  data() {
    return {
      searchInput: ""
    };
  },
  mounted() {
    this.searchInput = this.filterSearch;
  },
  computed: {
    filterSearch: {
      get() {
        return this.$store.getters["event/getFilterSearch"];
      },
      set(value) {
        this.$store.commit("event/SET_FILTER_SEARCH", value);
      }
    },
    filterRegistered: {
      get() {
        return this.$store.getters["event/getFilterRegistered"];
      },
      set(value) {
        this.$store.commit("event/SET_FILTER_REGISTERED", value);
        this.retrieveParticipants();
      }
    }
  },
  methods: {
    search() {
      this.filterSearch = this.searchInput;
      this.retrieveParticipants();
    },
    async retrieveParticipants() {
      try {
        this.$store.commit("loader/SET_LOADER", {});
        await this.$store.dispatch("event/retrieveParticipants", {
          eventId: this.eventId,
          hasPagination: true,
          initial: true
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("loader/RESET");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
